const $ = window.jQuery;

function initFaq() {
	const $faq = jQuery('.wp-block-yoast-faq-block');

	// Hämta alla knappar som har klassen schema-faq-question
	const $buttons = $faq.find('.schema-faq-question');

	// Loop över varje knapp
	$buttons.each(function (index) {
		const $button = jQuery(this);
		const answerId = 'faq-answer-' + (index + 1);
		const questionId = 'faq-question-' + (index + 1);

		// Sätt ID på knappen (om du vill referera till den)
		$button.attr('id', questionId);

		// Om du vill koppla knappen till svaret
		$button.attr('aria-controls', answerId);

		// Hitta svaret, som är närmaste element med klassen schema-faq-answer?
		// (Eller syskon, eller hur du nu strukturerar det.)
		const $answer = $button.closest('.schema-faq-section').find('.schema-faq-answer');
		$answer.attr('id', answerId);
		$answer.attr('aria-hidden', 'true');

		// Klick/keydown-event
		$button.on('click keydown', function (event) {
			if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
				event.preventDefault();

				const expanded = $button.attr('aria-expanded') === 'true';
				// Stäng alla andra
				$buttons.not($button).attr('aria-expanded', 'false');
				jQuery('.schema-faq-answer').not($answer).slideUp('fast').attr('aria-hidden', 'true');

				if (expanded) {
					// Stäng
					$button.attr('aria-expanded', 'false');
					$answer.slideUp('fast').attr('aria-hidden', 'true');
				} else {
					// Öppna
					$button.attr('aria-expanded', 'true');
					$answer.slideDown('fast').attr('aria-hidden', 'false');
				}
			}
		});
	});
}

export default initFaq;
